import { render, staticRenderFns } from "./vipuserjk.vue?vue&type=template&id=6469ae6e&"
import script from "./vipuserjk.vue?vue&type=script&lang=js&"
export * from "./vipuserjk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports